"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";

type Faq = { question: string; answer: string };

export default function ProductFaqs({ faqs }: { faqs: Faq[] }) {
    const [open, setOpen] = useState<number | null>(null);

    return (
        <div className="flex flex-col w-full gap-4 md:gap-6">
            <h1 className="text-xl font-bold md:text-3xl">Frequently Asked Questions</h1>
            <div className="rounded-lg w-full space-y-2 md:space-y-3">
                {faqs.map((faq, i) => (
                    <div key={i} className="rounded-md overflow-hidden">
                        <button
                            onClick={() => setOpen(open === i ? null : i)}
                            className="flex w-full justify-between items-center gap-3 bg-primary text-left text-sm md:text-base px-4 py-3 md:px-4 md:py-4 font-medium text-white"
                        >
                            {faq.question}
                            <ChevronDown
                                className={`w-5 h-5 md:w-6 md:h-6 shrink-0 transition-transform duration-200 ${
                                    open === i ? "rotate-180" : ""
                                }`}
                            />
                        </button>
                        {open === i && (
                            <div className="border border-primary">
                                <p className="px-4 py-3 md:px-4 md:py-3 text-sm md:text-lg text-black leading-relaxed">
                                    {faq.answer}
                                </p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
}